<template>
	<v-modal>
		<template v-slot:header>
			<h1>About proof of funds</h1>
		</template>
		<div class="editorial beta">
			<p>Proof of funds is required when buying a property to ensure that the money used for the purchase, or towards the purchase, comes from a legitimate source and is not the proceeds of crime or money laundering. This is part of anti-money laundering (AML) regulations, which require buyers to demonstrate where their funds have originated from. Solicitors requires this proof before proceeding with a transaction.</p>
			<p class="heavy">Examples of legitimate sources of funds:</p>
			<ul class="list--disc">
				<li>
					<em class="heavy">Savings</em> – Money accumulated over time from employment income, investments, or other lawful means.
				</li>
				<li><em
					class="heavy">Sale of a Property</em> – Proceeds from selling a previous home or other real estate.
				</li>
				<li><em class="heavy">Inheritance</em> – Money received from a deceased relative's estate.</li>
				<li><em
					class="heavy">Gift from Family</em> – A financial gift from a family member, often supported by a letter confirming it is not a loan.
				</li>
				<li><em
					class="heavy">Investment Withdrawals</em> – Funds released from stocks, shares, or other legal investment accounts.
				</li>
				<li><em class="heavy">Pension Release</em> – Money taken from a pension fund, if applicable.</li>
				<li><em class="heavy">Business Profits</em> – Legitimate income or dividends from a business.</li>
			</ul>
			<p>Providing bank statements, sale contracts, inheritance letters, or other relevant documents helps verify the source of funds and ensures compliance with AML regulations.</p>
			<p>Your proof of funds can come from a combination of legitimate sources. For example, if you're purchasing a house for £100,000 with a £90,000 mortgage, you'll need to provide a £10,000 deposit. In this case, you only need to demonstrate the source of the £10,000, as mortgage funds from a lender are automatically considered legitimate.</p>
			<p>For instance, your £10,000 deposit could be made up of £5,000 from savings and £5,000 from an inheritance.</p>
		</div>
		<template v-slot:footer>
			<ul class="actions">
				<li v-if="instruction">
					<button class="button button--primary" @click.prevent="proceed()">Continue</button>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>
export default {
	props: {
		instruction: {
			required: false,
			type: Object,
			default() {
				return null;
			},
		},
		action: {
			required: false,
			type: String,
			default() {
				return null;
			},
		},
	},
	methods: {
		proceed() {
			this.$vmodal.replace({
				component: () => import("@/apps/clientPortal/views/instruction/components/modals/ProofOfFunds.vue"),
				props: {
					instructionId: this.instruction.id,
					goToContributionOnOpen: this.action === "contribution",
					goToSourceOnOpen: this.action === "source",
				},
			});
		},
	},
};
</script>
